import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { MemberListFilter } from "@upsquad/shared";
import { logOut } from "@/src/auth/store/auth-slice";

interface MemberListState {
	search: string;
	selectedGroupIds: string[];
	selectedMemberIds: string[];
	page: number;
	statusFilter: MemberListFilter;
}

const initialState: MemberListState = {
	search: "",
	selectedGroupIds: [],
	selectedMemberIds: [],
	page: 1,
	statusFilter: MemberListFilter.ACTIVE,
};

export const memberListSlice = createSlice({
	name: "memberList",
	initialState,
	reducers: {
		setSearch: (state, { payload }: PayloadAction<string>) => {
			state.search = payload;
			state.page = 1;
		},
		setSelectedGroupIds: (state, { payload }: PayloadAction<string[]>) => {
			state.selectedGroupIds = payload;
			state.page = 1;
		},
		setSelectedMemberIds: (state, { payload }: PayloadAction<string[]>) => {
			state.selectedMemberIds = payload;
		},
		toggleMemberSelection: (state, { payload }: PayloadAction<string>) => {
			const index = state.selectedMemberIds.indexOf(payload);
			if (index === -1) {
				state.selectedMemberIds.push(payload);
			} else {
				state.selectedMemberIds.splice(index, 1);
			}
		},
		clearSelection: (state) => {
			state.selectedMemberIds = [];
		},
		setPage: (state, { payload }: PayloadAction<number>) => {
			state.page = payload;
		},
		setStatusFilter: (state, { payload }: PayloadAction<MemberListFilter>) => {
			state.statusFilter = payload;
			state.page = 1;
			state.selectedMemberIds = [];
		},
		resetMemberListState: () => initialState,
	},
	extraReducers: (builder) => {
		builder.addCase(logOut, () => initialState);
	},
});

export const {
	setSearch,
	setSelectedGroupIds,
	setSelectedMemberIds,
	toggleMemberSelection,
	clearSelection,
	setPage,
	setStatusFilter,
	resetMemberListState,
} = memberListSlice.actions;
